<template>
<div >
	<Loader :show="loading || saving"></Loader>
	<b-modal id="modalEmployeePassword" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		
		<b-form @submit.prevent="save" v-if="!loading" novalidate >

			<b-form-group label="Contraseña nueva" class="mt-2">
				<b-form-input
					v-model="form.password"
					type="password"
					placeholder="Contraseña"
					:state="!validation.hasError('form.password')" 
				></b-form-input>
				<b-form-invalid-feedback>Ingrese una contraseña de al menos 6 caracteres</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Repetir contraseña" class="mt-2">
				<b-form-input
					v-model="form.passwordConfirm"
					type="password"
					placeholder="Contraseña"
					:state="!validation.hasError('form.passwordConfirm')" 
				></b-form-input>
				<b-form-invalid-feedback>Las contraseñas no coinciden</b-form-invalid-feedback>
			</b-form-group>
		
			<div class="overflow-hidden mt-3">
				<b-button type="submit" class="pull-right" size="sm" variant="primary">Confirmar cambios</b-button>
			</div>
						
		</b-form>

	</b-modal>	
</div>
</template>

<script>
import gql from 'graphql-tag'
import Loader from '@/components/Loader'
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'EmployeePasswordModal',
	components:{
		Loader
	},
	data () {
		return {
			title: 'Cambiar contraseña',
			show: false,
			loading: false,
			saving: false,
			id: null,
			form: {
				password: null,
				passwordConfirm: null,
			}
		}
	},
	validators: {
		'form.password': function (value) {
			return Validator.value(value).required().minLength(6);
		},
		'form.passwordConfirm, form.password': function (repeat, password) {
			if (this.validation.isTouched('form.passwordConfirm') || this.validation.isTouched('form.password')) {
				return Validator.value(repeat).required().match(password);
			}
		}
	},
	methods: {
		open (id) {
			this.id = id
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalEmployeePassword')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalEmployeePassword')
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					password	: this.form.password,
					passwordConfirm	: this.form.passwordConfirm
				}

				this.$apollo.mutate({
					mutation: gql`mutation ( $id: ID!, $data: UserPasswordInput! ){
						userPasswordChange( id: $id, data: $data) {
							id
						}
					}`,
					variables: {
						id: this.id,
						data: dataInput,
					}
				})
				.then(() => {
					this.$toast.success('Cambios guardados')
					this.$emit('updated')
					this.saving = false
					this.close()
				})
				.catch( (error) => {
					this.errors = this.parseGQLErrors(error)
					this.$toast.error('Error!')
					this.saving = false
				})
			}
		},
	}
}


</script>
